// src/components/bot/questions/NumberQuestion.tsx
// 🎨 NUMBER QUESTION COMPONENT - For numeric input
// ✅ UPDATED: Removed placeholder, min/max fields and false validation claims

import React from 'react';
import BaseQuestion from './BaseQuestion';
import styles from './Questions.module.css';
import { QuestionItem } from '../hooks/useBotForm';
import logger from '../../../utils/logger';

interface NumberQuestionProps {
  question: QuestionItem;
  index: number;
  onUpdate: (id: string, field: keyof QuestionItem, value: any) => void;
  onRemove: (id: string) => void;
  onMoveUp: () => void;
  onMoveDown: () => void;
  canMoveUp: boolean;
  canMoveDown: boolean;
  forceCollapsed?: boolean;
}

const NumberQuestion: React.FC<NumberQuestionProps> = (props) => {
  const { question } = props;

  logger.log('🔢 NumberQuestion: Rendering simplified number question:', question.id);

  return (
    <BaseQuestion {...props}>
      
      {/* ❌ REMOVED: typeSpecificOptions section - no more placeholder/min/max fields */}
      {/* ❌ REMOVED: validationInfo section with false validation claims */}

      {/* 🎯 NUMBER QUESTION PREVIEW - Simplified */}
      <div className={styles.questionPreview}>
        <div className={styles.previewLabel}>Preview:</div>
        <div className={styles.previewContent}>
          <div className={styles.previewQuestion}>
            {question.question || 'Enter your question above...'}
            {question.required && <span className={styles.requiredAsterisk}>*</span>}
          </div>
          <div className={styles.previewInput}>
            <input 
              type="number"
              placeholder="Enter a number"
              disabled
              className={styles.previewInputField}
            />
          </div>
        </div>
      </div>
      
    </BaseQuestion>
  );
};

export default NumberQuestion;